import { render, staticRenderFns } from "./video-vimeo.vue?vue&type=template&id=fb7abf06"
import script from "./video-vimeo.vue?vue&type=script&lang=js"
export * from "./video-vimeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports